// @flow

import { type TokenizedCard } from './types';

export function getLastFourDigits(tokenized: TokenizedCard): string {
  return tokenized['last_digits'];
}
